
import { ComponentRef } from '@angular/core';
import { SingleDataBindingControl } from '../cp-configuration/view-model/cp-input-control';
import { AbstractControlComponent } from '../cp-controls/abstract-control';

export const controlHasDataBinding = (control: any): control is SingleDataBindingControl => {
    return control ? Reflect.has(control, 'dataBinding') : false;
};
/**
 * controlla se esiste un control con un binding determinato
 * @param binding
 * @param controlsByGrid
 * @returns True se controllo esiste False altrimenti
 */
export const findControlWithSingleDataBinding = (
    binding: string,
    controlsByGrid: Record<string, ComponentRef<AbstractControlComponent>[]>,
): boolean => {
    if (!binding) return false;
    return Boolean(
        Object.values(controlsByGrid)
            .flat()
            .find((control) => {
                if (controlHasDataBinding(control.instance.control)) {
                    const dataBinding = control.instance.control.dataBinding.toString();
                    return dataBinding === binding;
                }
                return false;
            }),
    );
};

export class SignAfterSaveParams {
    print: boolean | undefined = false;
    signAfterSave: boolean | undefined = true;
}
